<template>
  <div class="best-offers-pagination">
    <button @click.prevent="onPrevPageHandler"
            type="button"
            class="best-offers-pagination__btn"
            :class="{'best-offers-pagination__btn_disabled': isFirstPage}"
            role="button">
      <svg-icon :icon="rtl ? 'straight-arrows/right' : 'straight-arrows/left'"/>
    </button>
    <div class="best-offers-pagination-text">
      <span>{{ currentPageModel + 1 }} / {{ displayTotalPages }}</span>
    </div>
    <button @click.prevent="onNextPageHandler"
            type="button"
            class="best-offers-pagination__btn"
            :class="{'best-offers-pagination__btn_disabled': isLastPage}"
            role="button">
      <svg-icon :icon="rtl ? 'straight-arrows/left' : 'straight-arrows/right'"/>
    </button>
  </div>
</template>

<script lang="ts">
import SvgIcon from "@/common/controls/SvgIconControl.vue";
import {isRtlElement} from "@/common/util/rtl";

export default {
  components: {
    SvgIcon,
  },
  props: {
    totalPages: {
      type: Number,
      default: 0,
    },
    modelValue: {
      type: Number,
      default: 0,
    },
  },
  emits: ["update:modelValue"],
  data() {
    return {
      rtl: false,
    };
  },
  computed: {
    isFirstPage() {
      return this.currentPageModel <= 0;
    },

    isLastPage() {
      return this.currentPageModel >= this.displayTotalPages - 1;
    },

    currentPageModel: {
      get() {
        return Number.isFinite(this.modelValue) ? this.modelValue : 0;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
    displayTotalPages() {
      const value = Number.isFinite(this.totalPages) ? this.totalPages : 0;
      return Math.max(1, value);
    },
  },
  mounted() {
    this.rtl = isRtlElement(this.$el);
  },
  methods: {
    onPrevPageHandler() {
      if (this.currentPageModel > 0) {
        this.currentPageModel -= 1;
      }
    },
    
    onNextPageHandler() {
      if (this.currentPageModel < this.displayTotalPages - 1) {
        this.currentPageModel += 1;
      }
    },
  },
}
</script>

<style lang="scss" scoped>


.best-offers-pagination {
  display: inline-flex;
  align-items: center;
}

.best-offers-pagination__btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;

  width: 30px;
  height: 30px;

  color: var(--btn-primary-text);
  background: var(--btn-primary);
  border-radius: var(--border-radius-md);
  border: none;
}

.best-offers-pagination__btn:not(.best-offers-pagination__btn_disabled):hover {
  box-shadow: var(--shadow-hover);
}

.best-offers-pagination__btn:not(.best-offers-pagination__btn_disabled):active {
  background-color: var(--btn-primary-active);
  //box-shadow: var(--shadow-hover);
}


.best-offers-pagination-text {
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  width: 84px;
  text-align: center;
}

.best-offers-pagination__btn_disabled {
  background-color: var(--btn-primary-disabled);
}
</style>




